module.exports = __webpack_public_path__ + "static/media/close.e85191c6.svg";